import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PesquisaSatisfacaoSiteComponent } from 'app/pesquisa-satisfacao-site/pesquisa-satisfacao-site.component';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { AcessoRestritoSiteService } from 'app/services/acesso-restrito.service';
import { DownloadService } from 'app/services/download.service';
import { MensagensService } from 'app/services/mensagens.service';
import { SiteService } from 'app/services/site.service';
import { ValidadorService } from 'app/services/validador.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { MinhaAreaSiteComponent } from 'app/minha-area-site/minha-area-site.component';
import { EventosService } from '../services/eventos.service';

@Component({
  selector: 'app-acesso-restrito-relatorios',
  templateUrl: './acesso-restrito-relatorios.component.html',
  styleUrls: ['./acesso-restrito-relatorios.component.css']
})
export class AcessoRestritoRelatoriosComponent implements OnInit, OnDestroy {
  @ViewChild(MinhaAreaSiteComponent) principal: MinhaAreaSiteComponent;
  idPensionista = 0;
  nomeUsuario = '';
  retornou = false;
  cpf: string;
  idSelecionado = 0;
  tipoReport = 'R';
  arquivos: any[] = [];
  inSpinner = false;

  reports: any[] = [];

  constructor(
    private pageTitleService: PageTitleService,
    private formBuilder: FormBuilder,
    public validadorService: ValidadorService,
    public downloadService: DownloadService,
    public servico: SiteService,
    private modalService: NgbModal,
    private eventosService: EventosService,
    public acessoRestritoSiteService: AcessoRestritoSiteService,
    public router: Router,
    public mensagensService: MensagensService
  ) {
    this.pageTitleService.setTitle('ContraCheques');
    /* Page subTitle */
    this.pageTitleService.setSubTitle('');
    const usuario = JSON.parse(localStorage.getItem('localUsuarioDerminas'));
    if (!!usuario) {
      this.cpf = usuario.cpf;
      this.nomeUsuario = usuario.nomeUsuario;
      this.idPensionista = usuario.idPensionista;

    } else {
      this.router.navigate(['acesso-restrito']);
    }
  }

  ngOnInit(): void {

    /*
    tabela MenuRelatorioSite
    1	Política de investimentos	border-primary	13
    2	Informações contábeis	border-primary	22
    3	Demonstrativo de investimentos	border-primary	23
    4	Demonstração atuarial	border-primary	28
    5	Indicadores de Gestão	border-primary	37
    6	Relatório Anual de Informações	border-primary	27
    7	Estatística de População e Benefícios	border-primary	39
    8	RDI - Resolução CNPC 32/2019	border-primary	999
    */

    this.acessoRestritoSiteService.menusRelatorioSite()
      .pipe(finalize(() => {
      }))
      .subscribe(result => {
        if (result.length > 0) {
          this.selecionar(result[0].id);
        }
        this.reports = result;
      },
        err => {
          this.reports = [
            {
              name: 'Política de investimentos',
              border_color: 'border-primary',
              id: 13
            },
            {
              name: 'Informações contábeis',
              border_color: 'border-primary',
              id: 22
            },
            {
              name: 'Demonstrativo de investimentos',
              border_color: 'border-primary',
              id: 23
            },
            {
              name: 'Demonstração atuarial',
              border_color: 'border-primary',
              id: 28
            },
            {
              name: 'RDI - Resolução CNPC 32/2019',
              border_color: 'border-primary',
              id: 999
            }
          ];
        });
  }

  ngOnDestroy() {
  }

  selecionar(idConteudo: number) {
    this.idSelecionado = idConteudo;
    if (idConteudo === 999) {
      this.tipoReport = 'X';
    } else {
      this.tipoReport = 'R';
      this.acessoRestritoSiteService.obterRelatoriosSite(idConteudo).
        subscribe(response => {
          this.arquivos = response;
        },
          err => console.log(err),
          () => this.arquivos
        );
    }
  }

  abrir(anexo: any) {
    this.inSpinner = true;
    this.servico.download(anexo.nomeDrive, 'anexos')
      .pipe(finalize(() => {
        this.inSpinner = false;
      })).
      subscribe(response => {
        window.open(response.url, '_blank')
        // this.mensagensService.openBase64FileInNewTab(response.base64, anexo.nomeAnexo);
      },
        err => {
          this.inSpinner = false;
          const erro = this.mensagensService.recuperarMensagemErro(err);
        });
  }

  sair() {
    this.eventosService.logout();
    localStorage.removeItem('localUsuarioDerminas');
    localStorage.removeItem('pesquisa');
    this.router.navigate(['acesso-restrito']);
  }

  voltar() {
    this.principal.voltando();
  }
}
